var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"pg-nao-encontrada"},[_c('h1',[_vm._v("Página não encontrada 👋")]),_c('router-link',{attrs:{"to":"/","title":"Retornar para home"}},[_vm._v("Voltar para home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }